import {inject, Injectable, PLATFORM_ID} from "@angular/core";
import {isPlatformBrowser} from "@angular/common";

declare var gtag: any;

@Injectable()
export class SeoTagsService {
  private readonly _platformId = inject(PLATFORM_ID);
  
  constructor() {}

  public init() {
    if (isPlatformBrowser(this._platformId)) {
      const script = document.createElement("script");
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-115Z6CXS64";
      script.async = true;
      document.getElementsByTagName("head")[0].appendChild(script);

      const gtagEl = document.createElement("script");
      const gtagBody = document.createTextNode(`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-115Z6CXS64');
    `);
      gtagEl.appendChild(gtagBody);
      document.getElementsByTagName("head")[0].appendChild(gtagEl);
    }
  }

  public addYektaNetScript() {
    if (isPlatformBrowser(this._platformId)) {
      const newScript = document.createElement('script');

      const scriptBody = document.createTextNode(`
       !function (t, e, n) {
        t.yektanetAnalyticsObject = n, t[n] = t[n] || function () {
            t[n].q.push(arguments)
        }, t[n].q = t[n].q || [];
        var a = new Date, r = a.getFullYear().toString() + "0" + a.getMonth() + "0" + a.getDate() + "0" + a.getHours(),
            c = e.getElementsByTagName("script")[0], s = e.createElement("script");
        s.id = "ua-script-w3dp0HTZ"; s.dataset.analyticsobject = n;
        s.async = 1; s.type = "text/javascript";
        s.src = "https://cdn.yektanet.com/rg_woebegone/scripts_v3/w3dp0HTZ/rg.complete.js?v=" + r, c.parentNode.insertBefore(s, c)
    }(window, document, "yektanet");`);

      newScript.appendChild(scriptBody);

      document.getElementsByTagName("head")[0].appendChild(newScript);
    }
  }

  public addMatomoScript() {
    if (isPlatformBrowser(this._platformId)) {
      const newScript = document.createElement("script");

      const scriptBody = document.createTextNode(`
        var _paq = window._paq = window._paq || [];
        /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
        _paq.push(["setCookieDomain", "*.webt.wejoiner.com"]);
        _paq.push(["setDomains", ["*.webt.wejoiner.com","*.pwat.wejoiner.com"]]);
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function() {
          var u="https://wejoiner.matomo.cloud/";
          _paq.push(['setTrackerUrl', u+'matomo.php']);
          _paq.push(['setSiteId', '3']);
          var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
          g.async=true; g.src='https://cdn.matomo.cloud/wejoiner.matomo.cloud/matomo.js'; s.parentNode.insertBefore(g,s);
        })();`
      );

      newScript.appendChild(scriptBody);

      document.getElementsByTagName("head")[0].appendChild(newScript);
    }
  }

  public logEvent(
    event?: string,
    category?: string,
    label?: string,
    value?: number,
  ) {
    if (event) {
      gtag("event", event, {
        event_category: category,
        event_label: label,
        // value: value,
      });
    }
  }
}
